import img1 from '../images/autumn.png';
import img2 from '../images/beach.png';
import img3 from '../images/creek.png';
import img4 from '../images/desert.png';
import img5 from '../images/dew.png';
import img6 from '../images/flower01.png';
import img7 from '../images/flower02.png';
import img8 from '../images/grass.png';
import img9 from '../images/lagoon.png';
import img10 from '../images/mountain.png';
import img11 from '../images/snow.png';
import img12 from '../images/sunset.png';
import mask from '../images/mask.png';
import target from '../images/target.png';

import DragPuzzle from '../account/puzzle';

document.addEventListener("DOMContentLoaded", () => {
  new DragPuzzle(1, 3, [
    img1, img2, img3, img4, img5, img6,
    img7, img8, img9, img10, img11, img12,
    mask, target
  ]);
});